import ApolloLinkTimeout from 'apollo-link-timeout';
import { getSharedConfig } from '../../common/helpers/configs';

export function createTimeoutLink() {
  const config = getSharedConfig();
  return new ApolloLinkTimeout(config.timeout);
}
